module.exports = __webpack_public_path__ + "img/goods_1.04beed1a.png";